import {post} from '@/utils/request';

/**
 * 审核模式屏蔽词清单设置
 * @param data 屏蔽词 用,隔开
 */
export function admin_blockwords_set(data) {
  return post('admin_blockwords_set', {data}, {
    clear: false,
  })
}
